import {
    ICON_SELECTOR
} from '@/enum/Selectors';

const FONT_SIZE_SELECTOR = `
h1,h2,h3,h4,h5,h6,p,a,dl,dt,li,ol,ul,th,td,span,blockquote,
div,section,article,main,aside,header,footer,nav,
label,button,input,textarea,select,
strong,em,b,i,u,s,small,big,mark,code,pre,q,cite,figcaption,legend,
.asw-text
`.replace(/\s+/g, '');

const ICON_SELECTOR_SET = new Set(ICON_SELECTOR);

export default function adjustFontSize(multiply: number = 1) {
    const elements = document.querySelectorAll(FONT_SIZE_SELECTOR);

    // Pass 1: Snapshot original font sizes and line heights
    elements.forEach((el: Element) => {
        const htmlEl = el as HTMLElement;
        // Skip elements that contain any class in ICON_SELECTOR_SET
        if (Array.from(htmlEl.classList).some(cls => ICON_SELECTOR_SET.has(cls))) {
            return;
        }

        if (!htmlEl.dataset.aswOrgFontSize) {
            const computedStyle = window.getComputedStyle(htmlEl);
            const fontSize = computedStyle.fontSize;
            // getComputedStyle returns pixels (e.g., "16px").
            // We use parseFloat to handle sub-pixel values correctly.
            const orgFontSize = parseFloat(fontSize);
            if (!isNaN(orgFontSize)) {
                htmlEl.dataset.aswOrgFontSize = String(orgFontSize);
            }

            const lineHeight = computedStyle.lineHeight;
            // Store original line height only if it's in pixels.
            // "normal" or unitless numbers adapt automatically to font size changes.
            if (lineHeight && lineHeight.endsWith('px')) {
                const orgLineHeight = parseFloat(lineHeight);
                if (!isNaN(orgLineHeight)) {
                    htmlEl.dataset.aswOrgLineHeight = String(orgLineHeight);
                }
            }
        }
    });

    // Pass 2: Apply new font sizes and line heights
    elements.forEach((el: Element) => {
        const htmlEl = el as HTMLElement;
        // Skip elements that contain any class in ICON_SELECTOR_SET
        if (Array.from(htmlEl.classList).some(cls => ICON_SELECTOR_SET.has(cls))) {
            return;
        }

        const orgFontSize = Number(htmlEl.dataset.aswOrgFontSize);
        const orgLineHeight = Number(htmlEl.dataset.aswOrgLineHeight);

        if (orgFontSize) {
            const newFontSize = orgFontSize * multiply;
            htmlEl.style.fontSize = `${newFontSize}px`;

            if (orgLineHeight) {
                const newLineHeight = orgLineHeight * multiply;
                htmlEl.style.lineHeight = `${newLineHeight}px`;
            }
        }
    });
}